// 此自定义uView Pro主题生成于2025-11-29 13:18
// 地址：https://uviewpro.cn/zh/guide/themeGenerate.html

export default [
  // 主题 1: 紫色
  {
    name: 'purple',
    label: '霞光紫',
    color: {
      primary: '#7c3aed',
      error: '#f43f5e',
      warning: '#f59e0b',
      success: '#10b981',
      info: '#6b7280',
      primaryLight: '#f3e8ff',
      errorLight: '#ffe4e6',
      warningLight: '#fef3c7',
      successLight: '#d1fae5',
      infoLight: '#f3f4f6',
      primaryDark: '#6d28d9',
      errorDark: '#e11d48',
      warningDark: '#d97706',
      successDark: '#059669',
      infoDark: '#4b5563',
      primaryDisabled: '#c4b5fd',
      errorDisabled: '#fbcfe8',
      warningDisabled: '#fde68a',
      successDisabled: '#a7f3d0',
      infoDisabled: '#d1d5db',
    },
  },

  // 主题 2: 绿色
  {
    name: 'green',
    label: '清翠绿',
    color: {
      primary: '#059669',
      error: '#dc2626',
      warning: '#eab308',
      success: '#16a34a',
      info: '#78716c',
      primaryLight: '#ecfdf5',
      errorLight: '#fee2e2',
      warningLight: '#fefce8',
      successLight: '#dcfce7',
      infoLight: '#fafaf9',
      primaryDark: '#047857',
      errorDark: '#b91c1c',
      warningDark: '#ca8a04',
      successDark: '#15803d',
      infoDark: '#57534e',
      primaryDisabled: '#6ee7b7',
      errorDisabled: '#fca5a5',
      warningDisabled: '#facc15',
      successDisabled: '#86efac',
      infoDisabled: '#e7e5e4',
    },
  },

  // 主题 3: 橙色
  {
    name: 'orange',
    label: '暖阳橙',
    color: {
      primary: '#f97316',
      error: '#ef4444',
      warning: '#fbbf24',
      success: '#22c55e',
      info: '#6366f1',
      primaryLight: '#ffedd5',
      errorLight: '#fee2e2',
      warningLight: '#fef3c7',
      successLight: '#dcfce7',
      infoLight: '#e0e7ff',
      primaryDark: '#ea580c',
      errorDark: '#dc2626',
      warningDark: '#f59e0b',
      successDark: '#16a34a',
      infoDark: '#4f46e5',
      primaryDisabled: '#fed7aa',
      errorDisabled: '#fecaca',
      warningDisabled: '#fde68a',
      successDisabled: '#86efac',
      infoDisabled: '#c7d2fe',
    },
  },

  // 主题 4: 深蓝 / 黑蓝色系
  {
    name: 'dark',
    label: '午夜蓝',
    color: {
      primary: '#0b3d91',
      error: '#ef5350',
      warning: '#ffa726',
      success: '#66bb6a',
      info: '#2196f3',
      primaryLight: '#081a33',
      errorLight: '#5e1914',
      warningLight: '#663c00',
      successLight: '#1b3a1b',
      infoLight: '#003d66',
      primaryDark: '#062a57',
      errorDark: '#c62828',
      warningDark: '#e65100',
      successDark: '#2e7d32',
      infoDark: '#01579b',
      primaryDisabled: '#274a7a',
      errorDisabled: '#ef9a9a',
      warningDisabled: '#ffb74d',
      successDisabled: '#81c784',
      infoDisabled: '#4fc3f7',
    },
  },
]
